const API_URL = 'https://serene-depths-82382.herokuapp.com';

export default API_URL;
